import { backgroundColorWhite, borderColorDisabled } from './palette';

export const dragAndDropItemBgColor = backgroundColorWhite;
export const dragAndDropItemBorderColor = borderColorDisabled;
